import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

const Siege_perm = ({
  setCurrentform,
  currentform,
  setSiege_,
  siege_,
  sieges,
}) => {
  const updateSiege = (idSiege) => {
    console.log(idSiege);
    if (idSiege == '0') alert('Il Faut selectionner un siège');
    else setSiege_(idSiege);
  };
  useEffect(() => {
    console.log(sieges);
    setSiege_(sieges[0].IDSIEGE);
    console.log(`********** ${siege_}`);
  }, []);
  return (
    <div className='row'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='display-5 text-center'>
              Selectionner le Siège qui vous est le plus proche ?
            </h2>
          </div>
          <div className='card-body'>
            <Form>
              <Form.Row>
                <Form.Group as={Col} controlId='formSiege'>
                  <Form.Label>Siège</Form.Label>
                  <Form.Control
                    as='select'
                    value={siege_}
                    onChange={(e) => {
                      updateSiege(e.target.value);
                    }}
                  >
                    {/* <option key={0} value='0'>
                      Selectionner un Siège
                    </option> */}
                    {sieges.map((s) => (
                      <option key={s.IDSIEGE} value={s.IDSIEGE}>
                        {s.DENOMSI}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <div className='d-flex justify-content-end mt-4'>
                  {siege_ && (
                    <button
                      className='btn btn-small btn-info'
                      onClick={(e) => {
                        if (!siege_ || siege_ == '0') {
                          console.log(' $$$$$$$$$$$$$$$$$$$$$$$$$ ');
                          console.log(sieges);
                          //setSiege_(sieges[0].IDSIEGE);
                          alert('Il faut selectionner un siege');
                        } else setCurrentform(currentform + 1);
                      }}
                    >
                      Continuer
                    </button>
                  )}
                </div>
              </Form.Row>
            </Form>
          </div>

          <div className='card-footer'>
            {/*            
            <div className='d-flex justify-content-between'>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                Departement
              </button>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform + 1)}
              >
                An&Matricule&Session
              </button>
            </div>
           */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Siege_perm;
